import {
  TextField,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

export default function SearchBar({
  searchTerm,
  setSearchTerm,
  savedSearchName,
  setSavedSearchName,
  saveCurrentSearch,
  savedSearches,
  selectedSavedSearch,
  loadSavedSearch,
  deleteSavedSearch,
}) {
  return (
    <Box sx={{ display: "grid", gap: 1.5 }}>
      <TextField
        label="Search companies..."
        variant="outlined"
        size="small"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) 140px" },
          gap: 1.5,
          width: "100%",
        }}
      >
        <TextField
          label="Save search as..."
          variant="outlined"
          size="small"
          fullWidth
          value={savedSearchName}
          onChange={(e) => setSavedSearchName(e.target.value)}
        />

        <Button
          variant="outlined"
          onClick={saveCurrentSearch}
          disabled={!savedSearchName.trim()}
          sx={{ height: 34, whiteSpace: "nowrap", fontSize: "0.82rem" }}
        >
          Save Search
        </Button>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1fr) 140px" },
          gap: 1.5,
          width: "100%",
        }}
      >
        <FormControl fullWidth size="small">
          <InputLabel>Load Search</InputLabel>
          <Select
            value={selectedSavedSearch}
            label="Load Search"
            onChange={(e) => loadSavedSearch(e.target.value)}
          >
            <MenuItem value="">None</MenuItem>
            {savedSearches.map((search) => (
              <MenuItem key={search.name} value={search.name}>
                {search.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="outlined"
          color="error"
          onClick={deleteSavedSearch}
          disabled={!selectedSavedSearch}
          sx={{ height: 34, whiteSpace: "nowrap", fontSize: "0.82rem" }}
        >
          Delete
        </Button>
      </Box>
    </Box>
  );
}
